module.exports = __webpack_public_path__ + "static/profile-pic-3a6dde8b31050a6ea4b9261c3afce9d9.jpg";